import {
    BaseLeaseCategory,
    ContractCurrency,
    ProductType,
} from 'app/enums/label.enums'
import {
    SkyDataGridColumnDefinition,
} from 'app/shared-components/SkyBaseDataGrid'
import {
    APricingStandardBaseLeaseFilterRequestResponse,
} from 'app/requests/APricingRateCard/APricingRateCard.types'

const getColumns = ({
    classes,
}: {
    classes: {
        rightAlign: string,
    }
}): SkyDataGridColumnDefinition<APricingStandardBaseLeaseFilterRequestResponse>[] => {
    return [
        {
            name: 'baseLeaseCategory',
            componentName: 'EnumValue',
            allowedValuesEnum: BaseLeaseCategory,
            labelKey: 'BASE_LEASE_CATEGORY',
            maxWidth: 200,
        },
        {
            name: 'productType',
            componentName: 'EnumValue',
            allowedValuesEnum: ProductType,
            labelKey: 'PRODUCT_TYPE',
            maxWidth: 120,
        },
        {
            name: 'currency',
            componentName: 'EnumValue',
            allowedValuesEnum: ContractCurrency,
            labelKey: 'CURRENCY',
            maxWidth: 100,
        },
        {
            name: 'baseFeeValue',
            className: classes.rightAlign,
            labelKey: 'UP_TO_5_DAYS',
        },
        {
            name: 'additionalPeriodOne',
            className: classes.rightAlign,
            labelKey: 'DAY_6_TO_10',
        },
        {
            name: 'additionalPeriodTwo',
            className: classes.rightAlign,
            labelKey: 'DAY_11_TO_15',
        },
        {
            name: 'additionalPeriodThree',
            className: classes.rightAlign,
            labelKey: 'DAY_16_AND_MORE',
        },
    ]
}

export default getColumns
